<template>
	<div>
		<el-tabs type="border-card">
			<el-tab-pane label="文字回复">
				<el-form label-width="80px" :model="so">
					<el-form-item label="状态">
						<el-radio-group v-model="so.zhuangtai" size="small">
							<el-radio-button label="">不限</el-radio-button>
							<el-radio-button label="1">启用</el-radio-button>
							<el-radio-button label="2">禁用</el-radio-button>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="关键词">
						<el-input v-model="so.guanjianci" style="width: 80%;" size="medium"></el-input>
						<el-button size="medium" @click="CSH">搜索</el-button>
					</el-form-item>
				</el-form>
				<el-divider></el-divider>
				<el-table :data="lie" style="width: 100%">
					<el-table-column label="标题(关键字)" width="880">
						<template slot-scope="shu">
							<span style="margin-left: 10px">{{ shu.row.ming }}</span>
							<el-tag type="info" effect="dark" size="mini" style="margin-left: 20px">{{ shu.row.ci }}</el-tag>
						</template>
					</el-table-column>
					<el-table-column align="right">
						<template slot="header">
							<el-button type="danger" size="mini" @click="Mianbandakai(['huifu'])">新增回复</el-button>
						</template>
						<template slot-scope="shu">
							<el-button type="primary" size="mini" @click="Mianbandakai(['huifu',shu.row])">编辑</el-button>
							<el-button size="mini" type="danger" @click="Shanchu(shu.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination layout="total,prev,pager,next,jumper" :total="zongshu" :page-size="jitiao" :current-page.sync="ye" @current-change="CSH" style="margin-top: 30px;"/>
				
			</el-tab-pane>
		</el-tabs>
		<!-- 设置文字弹框 -->
		<el-dialog title="基本文字回复" :visible.sync="mianban.huifu">
			<el-form :model="mianban_shu">
				<el-form-item label="名称" label-width="100px">
					<el-input v-model="mianban_shu.ming" autocomplete="off"></el-input>
					<div class="tishi">您可以给这条规则起一个名字, 方便下次修改和查看.</div>
				</el-form-item>
				<el-form-item label="触发关键字" label-width="100px">
					<el-input v-model="mianban_shu.ci" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="回复内容" label-width="100px">
					<el-input type="textarea" v-model="mianban_shu.neirong" :rows="5" placeholder="请输入内容" />

				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="mianban.huifu = false">取 消</el-button>
				<el-button type="primary" @click="Mianban_post('huifu')">提 交</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	let that;
	export default {
		data() {
			return {
				ye: 1,
				zongshu: 0,
				jitiao: 20,
				so: {
					zhuangtai: ''
				},
				lie: [],
				mianban: {
					huifu: false
				},
				mianban_shu: {}
			}
		},
		created() {
			that = this;
			this.CSH();
		},
		methods: {
			CSH() {
				that.so.ye = that.ye;
				that.so.jitiao = that.jitiao;
				this.$post('k=huifu&c=wenzi', that.so, function(s) {
					that.lie = s.shu.lie;
					that.zongshu = Number(s.shu.zongshu);
				});
			},
			Mianbandakai(e) {				
				that.mianban[e[0]] = true;
				that.mianban_shu = e[1] || {};
			},
			Mianban_post(e) {
				if (e == 'huifu') {
					that.mianban_shu.leixing="wenzi";
					this.$post('k=huifu&c=xiugai', that.mianban_shu, function(s) {
						that.$xiaoxi(s.shu);
						if (s.shi == 1) {
							that.CSH();
							that.mianban[e] = false;
						}
					});
				}
				
			},
			Shanchu(e){
				this.$post('k=huifu&c=shandiao',{id:e.id}, function(s) {
					that.$xiaoxi(s.shu);
					if (s.shi == 1) {
						that.CSH();
					}
				});
			}
		}
	}
</script>

<style scoped>

</style>
